import { ChangeEvent, useEffect, useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { DictionaryItem } from '../../../../hoc/new-application/types';
import { COFAndIndividualQuestionnarieFormValues } from '../../../../hoc/individual/types';

const useSourceAndSizeOfWealth = ({
  sourceOfWealthForIndividual,
  questionnarieFields,
  sourceOfWealthForIndividualValues,
  questionnarieSetValue,
  sourceOfWealthForIndividualValue,
}: {
  sourceOfWealthForIndividual?: DictionaryItem[];
  questionnarieFields?: COFAndIndividualQuestionnarieFormValues;
  sourceOfWealthForIndividualValues?: {
    id?: string | undefined;
    sourceId: string;
    value: string | number;
  }[];
  questionnarieSetValue?: UseFormSetValue<COFAndIndividualQuestionnarieFormValues>;
  sourceOfWealthForIndividualValue?: {
    id?: string | undefined;
    sourceId: string;
    value: string | number;
  };
}) => {
  const [
    sourceOfWealthForIndividualFiltered,
    setSourceOfWealthForIndividualFiltered,
  ] = useState<DictionaryItem[]>();
  const [totalValue, setTotalValue] = useState(0);
  const [formValues, setFormValues] = useState<{
    id?: string;
    sourceId: string;
    value: number | string;
  }>();
  const [listVisible, setListVisible] = useState(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextFormValues = { ...formValues };

    const nextSourceOfWealthForIndividualValues =
      sourceOfWealthForIndividualValues?.map((item) => {
        const result = { ...item };

        if (result.id === sourceOfWealthForIndividualValue?.id) {
          if (e.target.name === `sourceId-${result.id}`) {
            result.sourceId = e.target.value;
            nextFormValues.sourceId = e.target.value;
          } else if (e.target.name === `value-${result.id}`) {
            result.value = e.target.value;
            nextFormValues.value = e.target.value;
          }
        }

        return result;
      });

    setFormValues(
      nextFormValues as {
        id?: string;
        sourceId: string;
        value: number | string;
      },
    );

    if (questionnarieSetValue) {
      questionnarieSetValue(
        'sourcesAndSizesOfWealth',
        nextSourceOfWealthForIndividualValues as {
          sourceId: string;
          value: number | string;
        }[],
      );
    }
  };

  const onDelete = () => {
    if (questionnarieSetValue) {
      questionnarieSetValue(
        'sourcesAndSizesOfWealth',
        sourceOfWealthForIndividualValues?.filter(
          (item) =>
            item?.sourceId !== sourceOfWealthForIndividualValue?.sourceId &&
            item?.id !== sourceOfWealthForIndividualValue?.id,
        ),
      );
    }
  };

  useEffect(() => {
    if (sourceOfWealthForIndividualValue) {
      setFormValues(sourceOfWealthForIndividualValue);
    }
  }, [sourceOfWealthForIndividualValue]);

  useEffect(() => {
    if (
      sourceOfWealthForIndividual &&
      questionnarieFields?.sourcesAndSizesOfWealth
    ) {
      setSourceOfWealthForIndividualFiltered(
        sourceOfWealthForIndividual?.filter((item) =>
          questionnarieFields?.sourcesAndSizesOfWealth?.every(
            (income) => item.id !== income.sourceId,
          ),
        ),
      );
    }
  }, [
    questionnarieFields?.sourcesAndSizesOfWealth,
    sourceOfWealthForIndividual,
  ]);

  useEffect(() => {
    if (
      questionnarieFields?.sourcesAndSizesOfWealth?.filter(
        (item) => item.sourceId,
      )?.length
    ) {
      let totalSourceOfIncome = 0;

      questionnarieFields?.sourcesAndSizesOfWealth
        ?.filter((item) => item.sourceId)
        ?.forEach((item) => {
          totalSourceOfIncome += Number(item.value);
        });

      setTotalValue(totalSourceOfIncome);
    }
  }, [questionnarieFields?.sourcesAndSizesOfWealth]);

  return {
    sourceOfWealthForIndividualFiltered,
    totalValue,
    setListVisible,
    listVisible,
    formValues,
    onChange,
    onDelete,
  };
};

export default useSourceAndSizeOfWealth;
